<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>

<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="姓名:" prop="name">
                <Input type="text" v-model="formData.name"></Input>
            </FormItem>
            <FormItem label="手机:" prop="mobile">
                <Input type="text" v-model="formData.mobile"></Input>
            </FormItem>
            <FormItem label="分账比例" prop="account_per">
                <Input type="text" v-model="formData.account_per" placeholder="例: 10为10%"></Input>
            </FormItem>
            <FormItem label="密码:" prop="pwd">
                <Input type="password" v-model="formData.pwd"></Input>
            </FormItem>
            <FormItem label="状态：" prop="status">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">
                        <span>显示</span>
                    </Radio>
                    <Radio label="2">
                        <span>隐藏</span>
                    </Radio>
                </RadioGroup>
            </FormItem>

            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model3",
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    name: '',
                    mobile: '',
                    pwd: '',
                    status: '1',
                    account_per:''
                }, 
                ruleCustom: {//验证
                    name: [
                        {required: true, message: '姓名不能为空', trigger: 'blur' },
                    ],
                    mobile: [
                        {required: true, message: '手机不能为空', trigger: 'blur' },
                        { type: 'string', pattern: /^1\d{10}$/i, message:'手机格式错误', trigger:'blur'},
                    ],
                   
                    status: [
                        {required: true, message: '状态不能为空', trigger: 'change' },
                    ],
                    account_per: [
                        {required: true, message: '分账比例不能为空', trigger: 'blur' },
                    ],
                },
            }
        },
        components: {
        },
        watch:{
            showModel(val){
                if(val){
                }
            }
        },
        created(){
            
        },
        methods: {
            
            openOrClose(value) {
                if(value === true) {
                    if(this.type == 2){//编辑表单时，给表单赋值
                        this.formData.name = this.editFormData.name.toString();
                        this.formData.mobile = this.editFormData.mobile.toString();
                        this.formData.status = this.editFormData.status.toString();
                        this.formData.account_per = this.editFormData.account_per.toString();
                        
                    }        
                    this.title = this.type == 1?'添加员工':'编辑员工'
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;

                        if (this.type == 2) {
                            this.formData.id = this.editFormData.id
                            
                        }else if(this.formData.pwd == ''){
                            common.msg('error','密码必须填写',()=>{this.disabled = false;})
                            return
                        }                      

                        this.axios.post(this.config.urlArray.empStore, this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false; })
                            
                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                if(this.type == 2){
                    delete this.formData.id
                }
            }
        }
    }
</script>
